import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class UptimeI18nService {
  private readonly translate = inject(TranslateService);

  public readonly dayShort = toSignal(this.translate.stream('timer.dayShort'), {
    initialValue: this.translate.instant('timer.dayShort') as string,
  });
}
